import _map from 'lodash/map';
import { Recruiter } from '../../../../../firebase/firestore/documents/recruiter';
import { useQueryOnce } from '../../../../../firebase/firestore/hooks';
import { Collections } from '../../../../../firebase/firestore/collections';
import { Query } from '../../../../../firebase/firestore/query/query';
import { User } from '../../../../../firebase/firestore/documents/user';
import { useCurrentUserProfile } from '../../../../../app/hooks/useCurrentUserProfile';

const useAccessibleAccounts = (): Recruiter[] => {
  const { currentUserProfile } = useCurrentUserProfile();
  const accountId = currentUserProfile?.account;

  const recruiters: User[] | undefined = useQueryOnce<User>(Collections.USERS, [
    Query.field<any>('operator.enabled').equals(true),
    Query.field<any>('operator.accessibleAccounts').arrayContains(accountId),
    Query.field<User>('isEmployer').equals(true),
  ]);

  if (recruiters && currentUserProfile && accountId) {
    return _map(recruiters, (r) => {
      return r as Recruiter;
    });
  }

  return [];
};

export default useAccessibleAccounts;
